import React from 'react'
import BackButton from '../commanComponents/buttons/BackButton'
import svgData from '../constants/utilities/svgData'

export default function PageNotFound() {
  return (
    <div className='pageNotFoundWrapper'>
      <div className='d-flex flex-column gap-3 justify-content-center align-items-center'>
      <h1> {svgData?.pageNotFoundIcon} Oops !</h1>
      <h5>Sorry, The page you are looking for doesn't exist, <br /> no longer exists or has been moved.</h5>
      <BackButton/>
      </div>
    </div>
  )
}
